import React from 'react'
import { LoadingMaskColorValue } from '.'
import { LoadingMaskRectangle } from './loading-mask-rectangle'

export function LoadingMaskSquare({
  size,
  borderRadius,
  className,
  colorValue
}: {
  readonly size: number
  readonly borderRadius?: number
  readonly className?: string
  readonly colorValue?: LoadingMaskColorValue
}) {
  return (
    <LoadingMaskRectangle
      width={size}
      height={size}
      borderRadius={borderRadius}
      className={className}
      colorValue={colorValue}
    />
  )
}
